import React from "react";
import LoadingSpinner from "./LoadingSpinner";

interface IProps {
  children: any;
  loading: boolean;
  noHeight?: boolean;
}

const LoadableComponent: React.FC<IProps> = ({ children, loading, noHeight = false }: IProps) => {
  return <React.Fragment>{loading ? <LoadingSpinner minHeight={noHeight ? "0" : "10vh"} /> : children}</React.Fragment>;
};

export default LoadableComponent;
